import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';

import { translate } from 'react-i18next';

import MenuItem from '../menus/MenuItem';

const styles = {
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  subheader: {
    marginLeft: '-8px'
  }
};

class Sidebar extends PureComponent {

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('layout.navigation.sidebar', {returnObjects: true});
  }

  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <List>
          <MenuItem
            icon='home'
            title={this.texts.items.all.home}
            link='/'
            onClick={event => this.props.onNavigation(event.currentTarget.id)}
          />
        </List>
        <Divider />
        <List
          subheader={
            <ListSubheader component="div" className={classes.subheader}>
              {this.texts.items.artist.subheader}
            </ListSubheader>
          }
        >
          <MenuItem
            icon='queue_music'
            title={this.texts.items.artist.tracks}
            link='/artist/tracks'
            onClick={event => this.props.onNavigation(event.currentTarget.id)}
          />
          <MenuItem
            icon='assignment'
            title={this.texts.items.artist.orders}
            link='/artist/orders'
            onClick={event => this.props.onNavigation(event.currentTarget.id)}
          />
        </List>
        <Divider />
      </div>
    );

    return (
      <div>
        <Drawer
          open={this.props.isOpen}
          onClose={this.props.onClose}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={this.props.onClose}
            onKeyDown={this.props.onClose}
          >
            {sideList}
          </div>
        </Drawer>
      </div>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default translate('translations')(withStyles(styles)(Sidebar));



// WEBPACK FOOTER //
// ./src/components/modules/navigation/Sidebar.js